import { FC } from 'react';
import styled from 'styled-components';
import { H3, LabelRegular } from '../typography/typography';
import Backdrop, { TOP_POSITION } from './base';

interface Props {
	title: string;
	message: string;
	confirmMessage?: string;
	onConfirm?: React.MouseEventHandler<HTMLButtonElement>;
	rejectMessage?: string;
	onReject?: React.MouseEventHandler<HTMLButtonElement>;
	zIndex?: string;
	vertical?: boolean;
	marginTop?: string;
}

interface BinaryQuestionInnerProps {
	children: React.ReactNode;
	marginTop?: string;
}

interface DividerProps {
	vertical?: boolean;
}

export const BinaryQuestionInner: FC<BinaryQuestionInnerProps> = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	margin-top: ${props => (props.marginTop ? props.marginTop : '120px')};
	max-width: 491px;
	width: 74.4%;
	background-color: var(--binary-question-inner-background);
	border-radius: 3px;
`;

export const BinaryQuestionContentContainer = styled.div`
	padding: 25px 12px 25px 12px;
	display: flex;
	flex-direction: column;
	align-items: center;
	text-align: center;
`;

export const BinaryQuestionButtonContainer = styled.div`
	display: flex;
	flex-wrap: wrap;
	border-top: 1px solid var(--binary-question-divider-color);
	width: 100%;
`;

export const BinaryQuestionVerticalDivider = styled.div`
	width: 1px;
	background-color: var(--binary-question-divider-color);
`;

export const BinaryQuestionHorisontalDivider = styled.div`
	height: 1px;
	background-color: var(--binary-question-divider-color);
	width: 100%;
`;

export const BinaryQuestionButton = styled.button`
	color: var(--font-light);
	font: var(--h3);
	width: auto;
	flex-grow: 1;
	padding: 14px 0 14px 0;
`;

export const BinaryQuestionDivider: FC<DividerProps> = ({ vertical }) => {
	return vertical ? <BinaryQuestionHorisontalDivider /> : <BinaryQuestionVerticalDivider />;
};

const BinaryQuestion: FC<Props> = ({
	title,
	message,
	confirmMessage = '',
	onConfirm,
	rejectMessage = '',
	onReject,
	zIndex,
	vertical,
	marginTop
}) => (
	<Backdrop modalPosition={TOP_POSITION} transparentModal={false} zIndex={zIndex}>
		<BinaryQuestionInner marginTop={marginTop}>
			<BinaryQuestionContentContainer>
				<H3 mb={3}>{title}</H3>
				<LabelRegular>{message}</LabelRegular>
			</BinaryQuestionContentContainer>
			<BinaryQuestionButtonContainer>
				{confirmMessage ? (
					<BinaryQuestionButton onClick={onConfirm}>{confirmMessage}</BinaryQuestionButton>
				) : null}
				{confirmMessage && rejectMessage ? <BinaryQuestionDivider vertical={vertical} /> : null}
				{rejectMessage ? <BinaryQuestionButton onClick={onReject}>{rejectMessage}</BinaryQuestionButton> : null}
			</BinaryQuestionButtonContainer>
		</BinaryQuestionInner>
	</Backdrop>
);

export default BinaryQuestion;
